<template>
  <div class="license-plate-input">车牌输入框</div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
